import script from "./modal-client-submit.vue?vue&type=script&setup=true&lang=js"
export * from "./modal-client-submit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__